export default __webpack_public_path__ + "static/media/bo_0.45526fa1.mp3";